var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Upload"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24,
    id: "Boundary"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m14,14l-4,0l0,-3l-2,0l4,-4l4,4l-2,0l0,3m2,-3m-11,4l0,-10l14,0l0,10l-4,0a3,3 0 0 1 -6,0l-4,0m14,-12l-14,0a2,2 0 0 0 -2,2l0,14a2,2 0 0 0 2,2l14,0a2,2 0 0 0 2,-2l0,-14a2,2 0 0 0 -2,-2",
    id: "color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxArrowUp);
export default __webpack_public_path__ + "static/media/Inbox-Arrow-Up.0f707a919b6749b537a01281a20456c4.svg";
export { ForwardRef as ReactComponent };